import { Component, OnChanges, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { TextMessageTemplatesService } from '../../api/services/text-message-templates.service';
import { TextMessageTemplate } from '../../api/models/text-message-template';
import { CreateTextMessageTemplateRequest } from '../../api/models/create-text-message-template-request';
import { UpdateTextMessageTemplateRequest } from '../../api/models/update-text-message-template-request';

@Component({
  selector: 'app-sms-template-page',
  templateUrl: './sms-template-page.component.html',
  styleUrls: ['./sms-template-page.component.scss']
})
export class SmsTemplatePageComponent implements OnInit, OnChanges {

  public template: TextMessageTemplate | null = null;
  public form: UntypedFormGroup;
  public isNew = false;

  constructor(
    private textMessageTemplatesService: TextMessageTemplatesService,
    private builder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.form = this.builder.group({
      name: ['', Validators.required],
      description: [''],
      body: ['', Validators.required]
    });
  }

  public cancel(): void {
    this.router.navigate(['/settings/templates']);
  }

  public saveTemplate(): void {
    const formValues = this.form.value;

    if (this.isNew) {
      const request: CreateTextMessageTemplateRequest = {
        name: formValues.name,
        description: formValues.description || null,
        body: formValues.body,
      };
      this.textMessageTemplatesService.createTextMessageTemplate({ body: request }).subscribe((saved) => {
        this.template = saved;
        this.isNew = false;
        this.ngOnChanges();
        this.router.navigate(['/settings/templates/sms', saved.id]);
      });
    } else if (this.template) {
      const request: UpdateTextMessageTemplateRequest = {
        name: formValues.name,
        description: formValues.description || null,
        body: formValues.body,
      };
      this.textMessageTemplatesService.updateTextMessageTemplate({
        templateId: this.template.id,
        body: request
      }).subscribe((saved) => {
        this.template = saved;
        this.ngOnChanges();
      });
    }
  }

  public ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      if (params.has('templateId')) {
        const templateId = +params.get('templateId')!;
        this.textMessageTemplatesService.listTextMessageTemplates().subscribe((templates) => {
          this.template = templates.find(t => t.id === templateId) || null;
          this.ngOnChanges();
        });
      } else {
        this.template = { id: 0, name: '', description: null, body: '' };
        this.isNew = true;
        this.ngOnChanges();
      }
    });
  }

  public ngOnChanges(): void {
    if (this.template) {
      this.form.reset();
      this.form.patchValue({
        name: this.template.name,
        description: this.template.description || '',
        body: this.template.body || '',
      });
    }
  }
}
